/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_ScheduledInputs */

const en_status_scheduled = /** @type {(inputs: Status_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`scheduled`)
};

const he_status_scheduled = /** @type {(inputs: Status_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתוכנן`)
};

/**
* | output |
* | --- |
* | "scheduled" |
*
* @param {Status_ScheduledInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_scheduled = /** @type {((inputs?: Status_ScheduledInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_ScheduledInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_scheduled(inputs)
	return he_status_scheduled(inputs)
});